import { User } from '../types';
import { fetchAPI } from './client';

export const UserAPI = {
  me: async (): Promise<User> => {
    return fetchAPI('/user/me', {
      method: 'GET',
    });
  },
  updatePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    return fetchAPI('/user/password', {
      method: 'PUT',
      body: JSON.stringify({currentPassword, newPassword})
    });
  },
  acceptTos: async (version: string): Promise<void> => {
    return fetchAPI('/user/accept-tos', {
      method: 'POST',
      body: JSON.stringify({ version }),
    });
  },
};